// extracted by mini-css-extract-plugin
export default {"card":"userlist_card__DQooy"};